import { Injectable } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { LectionaryYear } from '../components/lectionary-year/lectionary-year.component';

@Injectable()
export class LectionaryYearService {
 
  private cache: LectionaryYear[];

  constructor(private apiSvc: ApiService) { }

  public loadEntites(): Promise<LectionaryYear[]> {

    const p = new Promise<LectionaryYear[]>((resolve, reject) => {

      if (this.cache && this.cache.length > 0) {
        console.log("FeastType cache detected");
        resolve(this.cache);
        return;
      }
      
      this.apiSvc.get("api/LectionaryYear", null).subscribe(
        (data: LectionaryYear[]) => {
          this.cache = data;
          resolve(this.cache);
        },
        (err) => {
          console.log("error", err);
        }
      );

  });

  return p;

}

public getItem(itemId: number): Promise<LectionaryYear> {

  const p = new Promise<LectionaryYear>((resolve, reject) => {

    this.apiSvc.get("api/LectionaryYears/GetItem/" + itemId, null).subscribe(
      (data: LectionaryYear) => {
        console.log("LectionaryYears/GetItem", data);
        resolve(data);
      },
      (err) => {
        console.log("error", err);
      }
    );

  });

  return p;
}

  public save(model: LectionaryYear): Promise<LectionaryYear> {

    const p = new Promise<LectionaryYear>((resolve, reject) => {

      this.apiSvc.post("api/LectionaryYears/save", model).subscribe(
        (data: LectionaryYear) => {
            resolve(data);
        },
        (err) => {
          console.log("error", err);
        //  this.isLoading = false;
        }
      );

    });

  return p;
  }

}
